<template lang="html">
<div class="events" v-show="isActive">
  
  <v-card class="text-left ma-3">
    <v-card-title v-if="ewtitle">Upcoming Events
      <!--
          <v-spacer></v-spacer>
          <v-btn icon
                 color="teal accent-4"
                 :to="{path: '/events'}"
                 >
            <v-icon>mdi-calendar</v-icon>
          </v-btn>
          -->
    </v-card-title>
    <v-card-subtitle v-if="ewtime">
       Here are some of the upcoming events for Sky Farm members and their guests.
    </v-card-subtitle>
    <v-card-text>
      
      <v-list class="overflow-auto" :height="ewheight" v-if="ewtime">
        <template><div v-for="(item,i) in events" :key="i">
          <v-list-item-title :key="item.date" v-if="item.month"
                             ><b>{{ item.month }}</b></v-list-item-title>
          <template><div v-for="(event,e) in item.items" :key="e">
            <v-list-item-subtitle :key="event.uid">
              {{event.title}}
            </v-list-item-subtitle>
            </div>
          </template>
          </div>
        </template>
      </v-list>
      
      <v-list three-line  class="overflow-auto" :height="ewheight" v-else>
        <template v-for="item in events">
          <v-list-item-title :key="item.date"
                             ><b>{{ item.date }}</b></v-list-item-title>
            <template v-for="event in item.items">
              <v-list-item-subtitle :key="event.uid">
                <v-expansion-panels accordion>
                  <v-expansion-panel>
                    <v-expansion-panel-header v-bind:style="styleObject">
                        {{ event.time }}: {{event.title}}
                    </v-expansion-panel-header>
                    <v-expansion-panel-content width="60" v-if="ewdesc">
                      <span class="text-wrap" v-html="event.desc"></span>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
              </v-list-item-subtitle>
            </template>
          </template>
        </v-list>
        
      </v-card-text>
<!--
      <v-card-actions v-if="ewfooter">
        <v-btn
           text
           color="teal accent-4"
           :to="{path: '/events'}"
           >
          Events Calendar View
        </v-btn>
      </v-card-actions>
-->
    </v-card>
    
  </div>
</template>

<script>
import axios from 'axios'

export default {
    props: {
        ewtitle: {
            type: Boolean,
            default: true
        },
        ewtime: {
            type: Boolean,
            default: false
        },
        ewdesc: {
            type: Boolean,
            default: true
        },
        ewfooter: {
            type: Boolean,
            default: true
        },
        ewheight: {
            type: String,
            default: "340",
        },
    },
    data: function () {
        return {
            events: [],
            lastmonth: '',
            showmonth: false,
            isActive: true,
            hasEvents: false,
            styleObject: {
                padding: '5px 24px',
                'min-height': '12px',
            },
        }
    },
    methods: {
        getMonth(m) {
            console.log("[Widget::Events]: " + m)
            if ( m != this.lastmonth ) {
                this.lastmonth = m.str.split(/(\s+)/)[0];
                return this.lastmonth;
            }
        },
        getEvents() {
            console.log("[Widget:getEvents()]: Start")
            axios.get(`/events2.json`)
                .then(res => {
                    console.log("[Widget:getEvents()]: axios res: " + res)
                    this.events = res.data
                    this.hasEvents = true
                    this.returnResult()
                })
                .catch(err => {
                    console.log(err)
                    this.returnResult()
                })
        },
        returnResult() {

            var lm = '';
            var m  = '';
            var p  = [];
            for(var item in this.events) {
                m = this.events[item].date;
                p = m.split(/\s+/);
                console.log("[Widget:returnResult()]: m: " + m);
                console.log("[Widget:returnResult()]: p: " + p)
                if ( p[0] != lm ) {
                    lm = p[0];
                    this.events[item].month = p[0];
                }               
            }

            console.log("[Widget:getEvents()] foo: Event count:" + this.events.length )
            this.$emit('events-count',this.hasEvents)
        },
    },
    mounted() {
        this.getEvents()
    },

}

</script>

<style lang="css">
</style>
